export default "__VITE_ASSET__BUdZbv29__"